import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CardPost from "../components/CardPost";
import { posts as postsData } from "../data/posts";

function Posts() {
  const location = useLocation();
  const [posts, setPosts] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (location.state?.message) {
      setMessage(location.state.message);
      const timer = setTimeout(() => setMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  useEffect(() => {
    // Sắp xếp theo ngày mới nhất
    const sorted = [...postsData].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    setPosts(sorted);
  }, []);

  return (
    <div className="container max-w-7xl mx-auto px-4 py-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 tracking-tight mb-6">
        Bài Viết Mới Nhất
      </h2>

      {message && (
        <div className="bg-green-100 text-green-700 border border-green-400 px-4 py-3 rounded mb-6 text-center">
          {message}
        </div>
      )}

      <div className="post-list grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {posts.map((post) => (
          <CardPost key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
}

export default Posts;